import { NavLink, useLocation } from "react-router-dom"
import { FaFacebookF, FaInstagram, FaXTwitter } from "react-icons/fa6"


export const Footer = () => {
    const location = useLocation();
    const hideHeaderForAdmin = "admin";
    
    if (location.pathname.replace("/", "").startsWith(hideHeaderForAdmin)) {
        return <></>;
    }

    const footerLinkClasses = ({ isActive }: { isActive: boolean }) =>
        `hover:text-secondryBlue ${isActive ? "text-secondryBlue font-semibold" : "text-grayRgba"
        }`;

    return (
        <footer className="bg-white text-gray-300">
            <div className="w-full mx-auto px-10">
                {/* Top Row */}

                <div className="flex flex-col md:flex-row items-center justify-between py-2">
                    <div>
                        <img
                            src="/images/full-logo.png"
                            alt="Velox Charter"
                            className="h-auto w-[150px]"
                        />
                    </div>
                    {/* Navigation Links */}
                    <ul className="flex flex-wrap items-center justify-center md:justify-start gap-10 text-sm font-medium">
                        <li>
                            <NavLink to="/" className={footerLinkClasses}>Home</NavLink>
                        </li>
                        <li>
                            <NavLink to="/about-us" className={footerLinkClasses}>About Us</NavLink>
                        </li>
                        <li>
                            <NavLink to="/services" className={footerLinkClasses}>Services</NavLink>
                        </li>
                        <li>
                            <NavLink to="/fleet" className={footerLinkClasses}>Fleet</NavLink>
                        </li>
                        <li>
                            <NavLink to="/faq" className={footerLinkClasses}>FAQ</NavLink>
                        </li>
                        <li>
                            <NavLink to="/blog" className={footerLinkClasses}>Blog</NavLink>
                        </li>
                        <li>
                            <NavLink to="/contact-us" className={footerLinkClasses}>Contact Us</NavLink>
                        </li>
                    </ul>

                    {/* Payment Icons */}
                    <div className="flex items-center gap-4 mt-4 md:mt-0">
                        <img
                            src="/images/mastercard-logo.png"
                            alt="Mastercard"
                            className="h-[35px]"
                        />
                        <img
                            src="/images/visa-logo.png"
                            alt="Visa"
                            className="h-[35px]"
                        />
                        <img
                            src="/images/paypal-logo.png"
                            alt="PayPal"
                            className="h-[35px]"
                        />
                    </div>
                </div>

                {/* Bottom Row */}
                <div className="border-t border-[#D0D0D0] p-[15px] flex flex-col md:flex-row items-center justify-between gap-4 text-center md:text-left">


                    <p className="text-grayRgba text-sm font-medium">
                        © Velox Charter {new Date().getFullYear()}. All right reserved
                    </p>

                    {/* SOCIAL ICONS */}
                    <div className="flex items-center gap-4">
                        <FaFacebookF className="cursor-pointer text-grayRgba hover:text-secondryBlue" />
                        <FaXTwitter className="cursor-pointer text-grayRgba hover:text-secondryBlue" />
                        <FaInstagram className="cursor-pointer text-grayRgba hover:text-secondryBlue" />
                    </div>
                </div>
            </div>
        </footer>
    )
}